import { StatusIndicatorType } from "ui/atoms/avatar/statusIndicator/interfaces";

export enum SyncingRequestStatusEnum {
  COMPLETED = "COMPLETED",
  PROCESSING = "PROCESSING",
  FAILED = "FAILED",
}

export const StatusIndicatorMapping: Record<
  SyncingRequestStatusEnum,
  StatusIndicatorType
> = {
  [SyncingRequestStatusEnum.COMPLETED]: "active",
  [SyncingRequestStatusEnum.PROCESSING]: "warning",
  [SyncingRequestStatusEnum.FAILED]: "danger",
};
